<nz-modal
    [(nzVisible)]="isVisible"
    [nzMaskClosable]="false"
    nzTitle="Schedule Report Email Setting"
    [nzOkLoading]="submitLoading || loading"
    nzWidth="650px"
    (nzOnCancel)="close()"
    (nzOnOk)="submit()"
    [nzOkDisabled]="!time || (repeatType === 'Weekly' && DayHasChecked()?.length <= 0)"
>
    <ng-container *nzModalContent>
        <nz-spin [nzSpinning]="loading || recipientsTable.loading">
            <div nz-row class="row">
                <div nz-col [nzSpan]="4" class="label"> Active :</div>
                <nz-switch [(ngModel)]="enable"></nz-switch>
            </div>
            <div nz-row class="row">
                <div nz-col [nzSpan]="4" class="label"> Time :</div>
                <nz-time-picker [(ngModel)]="time" nzFormat="HH:mm"></nz-time-picker>
            </div>
            <div nz-row class="row repeat-row">
                <div nz-col [nzSpan]="4" class="label"> Repeat :</div>
                <div>
                   <div>
                       <nz-radio-group [(ngModel)]="repeatType" class="radio-select">
                           <label nz-radio nzValue="Daily">Daily</label>
                           <label nz-radio nzValue="Weekly">Weekly</label>
                       </nz-radio-group>
                   </div>
                    <nz-checkbox-group
                        [(ngModel)]="checkOptionsOne"
                        *ngIf="repeatType === 'Weekly'"
                        class="select-day"
                    ></nz-checkbox-group>
                </div>
            </div>
            <div nz-row class="row">
                <div nz-col [nzSpan]="4" class="label recipients-label"> Recipients </div>
                <div nz-col [nzSpan]="20"></div>
            </div>
            <div nz-row>
                <app-recipients-table style="width: 100%" #recipientsTable [currentUser]="currentUser" [type]="type" [editData]="selectUserEmails" [id]="id"></app-recipients-table>
            </div>
        </nz-spin>
    </ng-container>
</nz-modal>
